import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import FormButton from '../../../../../antd/form/FormButton/FormButton.jsx';
import Form from '../../../../../antd/form/Form/Form.jsx';
import FormItem from 'antd/es/form/FormItem';
import { phone, required } from '../../../../../antd/form/FormValidation.js';
import FormTextField from '../../../../../antd/form/FormTextField/FormTextField.jsx';
import FormFileUpload from '../../../../../antd/form/FormFileUpload/FormFileUpload.jsx';
import { useSaveInterestMutation } from '../../../../../../redux/services/fj_interests.jsx';
import { useNavigate } from 'react-router-dom';
import FormButtonsContainer from '../../../../../antd/form/FormButtonsContainer/FormButtonsContainer.jsx';
import { useToastMessages } from '../../../../../../hooks/useToastMessages.jsx';
import { QuestionModal } from '../../../../../common/index.jsx';

const FjInterestForm = ({
  id,
  fj_job_id,
  initialValues,
  mode,
  resumeObject,
  motivationLetterObject,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [saveInterest] = useSaveInterestMutation();

  const { saveSuccess } = useToastMessages();

  // Confirmation modal state for create mode
  const [confirmVisible, setConfirmVisible] = useState(false);
  const [pendingValues, setPendingValues] = useState(null);

  const handleFilesUpload = (formData) => {
    saveInterest({
      fj_job_id: fj_job_id,
      ...formData,
    })
      .unwrap()
      .then(() => {
        saveSuccess();
        // Always go back one page after successful create
        navigate(-1);
      });
  };

  const handleFilesUpdate = (id, formData) => {
    saveInterest({
      id: id,
      fj_job_id: fj_job_id,
      ...formData,
    })
      .unwrap()
      .then(() => {
        saveSuccess();
        // Always go back one page after successful update
        navigate(-1);
      });
  };

  return (
    <>
      <Form
        onFinish={(values) => {
          if (mode === 'edit') {
            handleFilesUpdate(id, values);
          } else {
            setPendingValues(values);
            setConfirmVisible(true);
          }
        }}
        initialValues={initialValues}
      >
        <FormItem>
          <FormTextField
            label={t('E-mailová adresa')}
            name="mail"
            rules={[required(t)]}
          />

          <FormTextField
            label={t('Telefónne číslo')}
            name="phone"
            rules={[required(t), phone(t)]}
          />

          <FormFileUpload
            label={t('Životopis')}
            name="resume_object"
            rules={[required(t)]}
            fileName={resumeObject}
          />

          <FormFileUpload
            label={t('Motivačný list')}
            name="motiv_letter_object"
            fileName={motivationLetterObject}
          />
        </FormItem>

        <div>
          <FormButtonsContainer>
            <FormButton submitOnClick={true} submitKey={'interest'}>
              {t('Uložiť')}
            </FormButton>
          </FormButtonsContainer>
        </div>
      </Form>

      <QuestionModal
        chosenPositive={() => {
          if (pendingValues) {
            handleFilesUpload(pendingValues);
            setPendingValues(null);
          }
          setConfirmVisible(false);
        }}
        question={t(
          'Po odoslaní formulára budú zadané informácie včítane životopisu a motivačného listu (ak ste ho priložili) zaslané e-mailom partnerovi FRI. Súhlasíte s tým a prajete si pokračovať?',
        )}
        visible={confirmVisible}
        yes={t('Áno')}
        toggle={() => setConfirmVisible(false)}
        headerTitle={t('Potvrdenie odoslania')}
      />
    </>
  );
};

FjInterestForm.prototype = {
  jobId: PropTypes.number,
  initialValues: PropTypes.any,
  onSubmit: PropTypes.func,
  mode: PropTypes.string,
  isAdmin: PropTypes.bool,
  refetchJobData: PropTypes.func,
};

export default FjInterestForm;
